import { gql } from '@apollo/client';

const GET_CONFIG_FLAGS = gql`
query ConfigFlagsSmallScreenNav {
    config {
      hasSearchMfe: genericType(name: "hasSearchMfe"),
      enableMobileNavRefresh: nonCachedGenericType(name: "enableMobileNavRefresh")
    }
  }
`;

const GET_SMALL_SCREEN_NAV_BAR_BRAND_LOGO = gql`
  query SmallScreenNavBarBrandLogo($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      brandLogoType
      url
    }
  }
`;

const GET_SMALL_SCREEN_NAVIGATION_AND_FOOTER_DATA = gql`
  query SmallScreenNavAndFooterData($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      id: categoryId
      brandLogoType
      url
      navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
        id: categoryId
        displayType
        title: name
        hasEspotContent
        navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
          id: categoryId
        }
        espotIdentifier
        mobileMenuUrl
        hasSpecialNavInteraction
      }
    }
    footer(isDesktop: false){
      footerLogos {
        id
        url
      }
      helpLinks {
        title
        url
        external
        id
      }
      aboutLinks {
        title
        url
        external
        id
      }
      utilityLinks {
        title
        url
        external
        id
      }
      contactUs {
        title
        url
        external
        id
      }
    }
  }
`;

// Background query - Levels 2, 3, 4
const GET_SMALL_SCREEN_NAV_LOWER_CATEGORIES = gql`
  query SmallScreenNavLowerCategories($categoryId: String!) {
    navigationCategory(categoryId: $categoryId) {
      navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
        id: categoryId
        title: name
        espotIdentifier
        mobileMenuUrl
        navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
          id: categoryId
          title: name
          displayType
          mobileMenuUrl
          navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
            id: categoryId
            title:name
            displayType
            mobileMenuUrl
            navigationSubCategories(hideCategory: false, removeEmptyNames: true) {
                id: categoryId
                title:name
                displayType
                mobileMenuUrl
            }
          }
        }
      }
    }
  }
`;

export {
  GET_SMALL_SCREEN_NAVIGATION_AND_FOOTER_DATA,
  GET_SMALL_SCREEN_NAV_LOWER_CATEGORIES,
  GET_CONFIG_FLAGS,
  GET_SMALL_SCREEN_NAV_BAR_BRAND_LOGO,
};
